import { useId, useInsertionEffect, useMemo } from 'react';

import { cssObjectToSheet } from '../helpers/cssObjectToSheet';

export function useDynamicStyles(css) {
  const cssClassName = `rbtn-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;
  const cssKey = css && typeof css === 'object' ? JSON.stringify(css) : '';
  const cssSheet = useMemo(
    () => (cssKey ? cssObjectToSheet(cssClassName, JSON.parse(cssKey)) : ''),
    [cssClassName, cssKey]
  );

  useInsertionEffect(() => {
    if (!cssSheet || typeof document === 'undefined') return undefined;

    const el = document.createElement('style');
    el.setAttribute('data-rbtn-css', cssClassName);
    el.textContent = cssSheet;
    document.head.appendChild(el);

    return () => {
      el.remove();
    };
  }, [cssSheet, cssClassName]);

  return { cssClassName, cssSheet };
}
